import { parseMentionToken } from './mentionTokens';

export const ASSISTANT_CHAT_INSERT_TAG_EVENT = 'assistant-chat:insert-tag';

export interface AssistantChatInsertTagDetail {
  tag: string;
  /** Human-friendly field label shown on the mention chip in the chat composer. */
  label?: string;
  append?: boolean;
  openAssistant?: boolean;
  separator?: string;
}

const mentionLabelByPath = new Map<string, string>();

const resolvePathFromPathOrTag = (pathOrTag: string): string | null => {
  const trimmed = pathOrTag.trim();
  if (!trimmed) {
    return null;
  }

  const parsed = parseMentionToken(trimmed);
  if (parsed?.path) {
    return parsed.path;
  }

  // Plain model-input path (not a full @model:input:path token).
  if (!trimmed.startsWith('@')) {
    return trimmed;
  }

  return null;
};

/**
 * Registers a display label for a model-input path (or full `@model:input:path` tag).
 * Used so mention chips can show field labels even when DOM lookup cannot resolve them.
 */
export const registerAssistantMentionLabel = (pathOrTag: string, label: string): void => {
  const trimmedLabel = label.trim();
  if (!pathOrTag || !trimmedLabel) {
    return;
  }

  const path = resolvePathFromPathOrTag(pathOrTag);
  if (!path) {
    return;
  }

  mentionLabelByPath.set(path, trimmedLabel);
};

export const getRegisteredAssistantMentionLabels = (): Record<string, string> => (
  Object.fromEntries(mentionLabelByPath.entries())
);

export const requestAssistantChatTagInsertion = (detail: AssistantChatInsertTagDetail): void => {
  if (!detail.tag) {
    return;
  }

  if (detail.label) {
    registerAssistantMentionLabel(detail.tag, detail.label);
  }

  window.dispatchEvent(
    new CustomEvent<AssistantChatInsertTagDetail>(ASSISTANT_CHAT_INSERT_TAG_EVENT, {
      detail,
    }),
  );
};
